import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { COLOR_RED } from "shared/theme/colors";
import { flex } from "shared/theme/mixins";

export const StyledBox = styled(Box)`
  ${flex({ ai: "center" })};
  padding: 0 0.5rem;
  height: 1.5rem;
  border-radius: 0.5rem;
  background-color: ${COLOR_RED};
`;
